import { api, ApiError } from '../api.ts';

/**
 * Where a request to connect says it will go back to, in words a person knows (design study 28, pick 2A): Claude on
 * claude.ai for either of its callbacks, Claude Code for a loopback address. The API has already refused any other
 * address, so one that is neither shows as its host, and a request that is not Claude's shows itself.
 */
export function goesTo(redirectUri: string): string {
  let url: URL;
  try {
    url = new URL(redirectUri);
  } catch {
    return redirectUri;
  }
  if (url.protocol === 'https:' && (url.hostname === 'claude.ai' || url.hostname === 'claude.com')) return 'Claude on claude.ai';
  if (url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1')) return 'Claude Code on this computer';
  return url.host;
}

/**
 * Whether the check of a request to connect could not be made at all (the portal answered with a fault, or not at all),
 * against a request it refused as one that does not hold. The first is worth trying again; the second is not.
 */
export function checkUnreached(e: unknown): boolean {
  return !(e instanceof ApiError) || e.status >= 500;
}

/** The answer to a request to connect, sent with the request's own fields as they came; where to send the browser next comes back. */
export async function answerAsk(search: string, allow: boolean): Promise<string> {
  const ask = Object.fromEntries(new URLSearchParams(search));
  return (await api<{ redirect: string }>('/oauth/authorize', { body: { ...ask, allow } })).redirect;
}
